import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';

import { candidateRejectionMessageQueryKeys } from './queryKeys';

interface CandidateRejectionMessagesParams {
  jobId: string;
  candidateIds: string[];
}

/**
 * Candidates out of `candidateIds` who would be sent a rejection message if
 * rejected now, each with the default message the API would send.
 */
export const useCandidateRejectionMessagesQuery = ({
  jobId,
  candidateIds,
}: CandidateRejectionMessagesParams) =>
  useQuery({
    queryKey: candidateRejectionMessageQueryKeys.list(jobId, candidateIds),
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        candidateEndpoints.rejectionMessages,
        { params: { path: { jobId }, query: { candidateIds } } },
      );

      return data?.recipients ?? [];
    },
  });
